import React from 'react';
import IconName from "../../../svgLogo/SvgLogo";

const CartListProduct = () => {
    return (
        <div className="cart-list-product-wrapper">
            <div className="unavailable-product">
                <IconName name="alert" className="icon"/>
                <span className="text">
                                    گوشی شیائومی می نوت ۹ پرو دوسیم کارت ظرفیت ۶۴ گیگابایت - ۶ گیگ رم ناموجود شده است و به طور خودکار از سبد خرید شما حذف می‌شود.
                                </span>
            </div>
            <div className="refresh-price-product xmt-4 d-none d-lg-flex">
                <IconName name="alert" className="icon"/>
                <span className="text">
                                  قیمت گوشی شیائومی می نوت ۹ پرو دوسیم کارت ظرفیت ۶۴ گیگابایت - ۶ گیگ رم تغییر کرده است، برای به‌روزرسانی قیمت رفرش کنید.
                                </span>
                <span className="reload-page" id="reload-change-price"><IconName name="refresh"
                                                                                 className="icon"/></span>
            </div>
            <div className="list-product blue-product position-relative xmt-6">
                <div className="price-box position-absolute">
                    <span className="price persian-number">۲،۷۶۰،۰۰۰ ت</span>
                </div>
                <div className="title-product-responsive d-block d-md-none">
                    <h3 className="small-title">Xiaomi Redmi Note 9 Pro Global Dual SIM 64GB- 6GB RAM</h3>
                </div>
                <div className="content-cart d-flex align-items-center">
                    <div className="img-product">
                        <img src="./assets/sample-image/1420-w320h320.png" alt="img"/>
                        <div className="add-remove-product-responsive d-flex d-md-none align-items-center">
                            <div className="remove-product"><IconName name="delete" className="icon"/></div>
                            <div className="add-product persian-number"><span className="number">+1</span></div>
                        </div>
                    </div>
                    <div className="info-product">
                        <div className="title-product d-none d-md-block">
                            <h2 className="big-title persian-number d-none d-lg-block">گوشی شیائومی می نوت 9 پرو دوسیم
                                کارت ظرفیت ۶۴ گیگابایت - ۶ گیگ
                                رم</h2>
                            <h3 className="small-title">Xiaomi Redmi Note 9 Pro Global Dual SIM 64GB- 6GB RAM</h3>
                        </div>
                        <div className="color-product d-flex align-items-center">
                            <span className="color black">
                            </span>
                            <span className="text-color">مشکی</span>
                        </div>
             {/*           <div className="seller-info d-none d-lg-flex align-items-center">
                            <div className="name-seller">
                                <IconName name="add_business" className="icon"/>
                                <span className="text">کامپیوتر زرد آذربایجان</span>
                            </div>
                            <div className="payment">
                                <IconName name="wallet" className="icon"/>
                                <span className="text">پرداخت در محل</span>
                            </div>
                        </div>*/}
                {/*        <div className="register-product d-none d-lg-block">
                            <IconName name="verified_user" className="icon"/>
                            <span className="text">  تضمین ثبت در شبکه رجیستری بدون هزینه اضافی (رجیستر شده)</span>
                        </div>*/}

                        <div className="text-info-product-responsive">
                            <div className="text-product-information">
                                <IconName name="verified_user" className="icon"/>
                                <span className="text">گارانتی ۱۸ ماهه‌ی سایمان</span>
                            </div>
                            <div className="text-product-information">
                                <IconName name="add_business" className="icon"/>
                                <span className="text">کامپیوتر زرد </span>
                            </div>
                            <div className="text-product-information">
                                <IconName name="date" className="icon"/>
                                <span className="text">ارسال کالا از ۱ روز کاری آینده</span>
                            </div>
                        </div>
                        <div className="add-remove-product d-none d-md-flex align-items-center position-absolute">
                            <div className="remove-product"><IconName name="delete" className="icon"/></div>
                            <div className="add-product persian-number"><span className="number">+1</span></div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="list-product purple-product position-relative xmt-6">
                <div className="price-box position-absolute">
                    <span className="price persian-number">۲،۷۶۰،۰۰۰ ت</span>
                </div>
                <div className="title-product-responsive d-block d-md-none">
                    <h3 className="small-title">Xiaomi Redmi Note 9 Pro Global Dual SIM 64GB- 6GB RAM</h3>
                </div>
                <div className="content-cart d-flex align-items-center">
                    <div className="img-product">
                        <img src="./assets/sample-image/1420-w320h320.png" alt="img"/>
                        <div className="add-remove-product-responsive d-flex d-md-none align-items-center">
                            <div className="remove-product"><IconName name="delete" className="icon"/></div>
                            <div className="add-product persian-number"><span className="number">+1</span></div>
                        </div>
                    </div>
                    <div className="info-product">
                        <div className="title-product d-none d-md-block">
                            <h2 className="big-title persian-number d-none d-lg-block">گوشی شیائومی می نوت 9 پرو دوسیم
                                کارت ظرفیت ۶۴ گیگابایت - ۶ گیگ
                                رم</h2>
                            <h3 className="small-title">Xiaomi Redmi Note 9 Pro Global Dual SIM 64GB- 6GB RAM</h3>
                        </div>
                        <div className="color-product d-flex align-items-center">
                            <span className="color black">
                            </span>
                            <span className="text-color">مشکی</span>
                        </div>
                        <div className="text-info-product-responsive">
                            <div className="text-product-information">
                                <IconName name="verified_user" className="icon"/>
                                <span className="text">گارانتی ۱۸ ماهه‌ی سایمان</span>
                            </div>
                            <div className="text-product-information">
                                <IconName name="add_business" className="icon"/>
                                <span className="text">کامپیوتر زرد </span>
                            </div>
                            <div className="text-product-information">
                                <IconName name="date" className="icon"/>
                                <span className="text">ارسال کالا از ۱ روز کاری آینده</span>
                            </div>
                        </div>
                        <div className="add-remove-product d-none d-md-flex align-items-center position-absolute">
                            <div className="remove-product"><IconName name="delete" className="icon"/></div>
                            <div className="add-product persian-number"><span className="number">+1</span></div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="list-product purple-product position-relative xmt-6">
                <div className="price-box position-absolute">
                    <span className="price persian-number">۲،۷۶۰،۰۰۰ ت</span>
                </div>
                <div className="title-product-responsive d-block d-md-none">
                    <h3 className="small-title">Xiaomi Redmi Note 9 Pro Global Dual SIM 64GB- 6GB RAM</h3>
                </div>
                <div className="content-cart d-flex align-items-center">
                    <div className="img-product">
                        <img src="./assets/sample-image/1420-w320h320.png" alt="img"/>
                        <div className="add-remove-product-responsive d-flex d-md-none align-items-center">
                            <div className="remove-product"><IconName name="delete" className="icon"/></div>
                            <div className="add-product persian-number"><span className="number">+1</span></div>
                        </div>
                    </div>
                    <div className="info-product">
                        <div className="title-product d-none d-md-block">
                            <h2 className="big-title persian-number d-none d-lg-block">گوشی شیائومی می نوت 9 پرو دوسیم
                                کارت ظرفیت ۶۴ گیگابایت - ۶ گیگ
                                رم</h2>
                            <h3 className="small-title">Xiaomi Redmi Note 9 Pro Global Dual SIM 64GB- 6GB RAM</h3>
                        </div>
                        <div className="color-product d-flex align-items-center">
                            <span className="color black">
                            </span>
                            <span className="text-color">مشکی</span>
                        </div>
                        <div className="text-info-product-responsive">
                            <div className="text-product-information">
                                <IconName name="verified_user" className="icon"/>
                                <span className="text">گارانتی ۱۸ ماهه‌ی سایمان</span>
                            </div>
                            <div className="text-product-information">
                                <IconName name="add_business" className="icon"/>
                                <span className="text">کامپیوتر زرد </span>
                            </div>
                            <div className="text-product-information">
                                <IconName name="date" className="icon"/>
                                <span className="text">ارسال کالا از ۱ روز کاری آینده</span>
                            </div>
                        </div>
                        <div className="add-remove-product d-none d-md-flex align-items-center position-absolute">
                            <div className="remove-product"><IconName name="delete" className="icon"/></div>
                            <div className="add-product persian-number"><span className="number">+1</span></div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="list-product purple-product position-relative xmt-6">
                <div className="price-box position-absolute">
                    <span className="price persian-number">۲،۷۶۰،۰۰۰ ت</span>
                </div>
                <div className="title-product-responsive d-block d-md-none">
                    <h3 className="small-title">Xiaomi Redmi Note 9 Pro Global Dual SIM 64GB- 6GB RAM</h3>
                </div>
                <div className="content-cart d-flex align-items-center">
                    <div className="img-product">
                        <img src="./assets/sample-image/1420-w320h320.png" alt="img"/>
                        <div className="add-remove-product-responsive d-flex d-md-none align-items-center">
                            <div className="remove-product"><IconName name="delete" className="icon"/></div>
                            <div className="add-product persian-number"><span className="number">+1</span></div>
                        </div>
                    </div>
                    <div className="info-product">
                        <div className="title-product d-none d-md-block">
                            <h2 className="big-title persian-number d-none d-lg-block">گوشی شیائومی می نوت 9 پرو دوسیم
                                کارت ظرفیت ۶۴ گیگابایت - ۶ گیگ
                                رم</h2>
                            <h3 className="small-title">Xiaomi Redmi Note 9 Pro Global Dual SIM 64GB- 6GB RAM</h3>
                        </div>
                        <div className="color-product d-flex align-items-center">
                            <span className="color black">
                            </span>
                            <span className="text-color">مشکی</span>
                        </div>
                        <div className="text-info-product-responsive">
                            <div className="text-product-information">
                                <IconName name="verified_user" className="icon"/>
                                <span className="text">گارانتی ۱۸ ماهه‌ی سایمان</span>
                            </div>
                            <div className="text-product-information">
                                <IconName name="add_business" className="icon"/>
                                <span className="text">کامپیوتر زرد </span>
                            </div>
                            <div className="text-product-information">
                                <IconName name="date" className="icon"/>
                                <span className="text">ارسال کالا از ۱ روز کاری آینده</span>
                            </div>
                        </div>
                        <div className="add-remove-product d-none d-md-flex align-items-center position-absolute">
                            <div className="remove-product"><IconName name="delete" className="icon"/></div>
                            <div className="add-product persian-number"><span className="number">+1</span></div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="total-price-product persian-number xmt-10">
                <ul className="list-unstyled">
                    <li className="d-flex justify-content-between align-items-center">
                        <div className="text">قیمت کالاها (2)</div>
                        <div className="price">17,338,000 ت</div>
                    </li>
                    <li className="d-flex justify-content-between align-items-center">
                        <div className="discount-products text">تخفیف کالاها</div>
                        <div className="red-price price">100,000 ت</div>
                    </li>
                    <li className="d-flex justify-content-between align-items-center">
                        <div className="text">جمع</div>
                        <div className="price blue-price">17,238,000 ت</div>
                    </li>
                </ul>
            </div>
        </div>
    );
};

export default CartListProduct;
